import { Button } from "@material-ui/core";
import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import DottedOutlineButton from "components/Layout/DottedOutlineButton";
import {
  StandardContainer,
  SubmitButtonsContainer,
} from "components/Layout/StandardStyledComponents";
import StepperFrame, {
  StepFrame,
  InvalidationCheck,
} from "components/Layout/StepperFrame";
import React, { Fragment, useState } from "react";
import styled from "styled-components";
import StepCard from "./StepCard";
import StepForm from "./StepForm";
import TaskItemListAndAdd, { TaskItemInput } from "./TaskItemListAndAdd";

const Container = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 12px 6px;
  justify-content: space-between;
  width: 40%;
`;

interface StepLocation {
  lat: number;
  lng: number;
  floorNumber: number;
}

export interface StepInput {
  name: string;
  taskItems: TaskItemInput[];
  stepLocation?: StepLocation;
}

interface StepCreatorProps {
  submitStep: (step: StepInput) => void;
  steps: StepInput[];
}

interface StepsCreatorState {
  editing: boolean;
  creatingStep: boolean;
  currentStep: StepInput;
}

const DEFAULT_STATE: StepsCreatorState = {
  editing: false,
  creatingStep: false,
  currentStep: {
    name: "",
    taskItems: [],
  },
};

export default function StepsCreator({ submitStep, steps }: StepCreatorProps) {
  const [state, setState] = useState<StepsCreatorState>(DEFAULT_STATE);
  const addStepButton = state.creatingStep ? null : (
    <DottedOutlineButton
      handleClick={() => setState({ ...state, creatingStep: true })}
      title="Add Step *"
    />
  );

  const submitTaskItem = (taskItem: TaskItemInput) => {
    const taskItems = state.currentStep.taskItems;
    taskItems.push(taskItem);
    setState((prevState) => ({
      ...prevState,
      currentStep: { ...prevState.currentStep, taskItems },
    }));
  };

  const handleNewLocation = (lat: number, lng: number, floorNumber: number) => {
    setState((prevState) => ({
      ...prevState,
      currentStep: {
        ...prevState.currentStep,
        stepLocation: {
          lat,
          lng,
          floorNumber,
        },
      },
    }));
  };

  const onWaypointCancel = () => {
    setState((prevState) => ({
      ...prevState,
      currentStep: {
        ...prevState.currentStep,
        stepLocation: undefined,
      },
    }));
  };

  const checkIfStepIsInvalid = (): InvalidationCheck => {
    let invalid = false;
    let message = "";
    if (state.currentStep.name === "") {
      invalid = true;
      message = "Please add a name to the step";
    }
    return { invalid, message };
  };

  const stepFrames: StepFrame[] = [
    {
      label: "Name and Configure Step",
      inValid: checkIfStepIsInvalid(),
      children: (
        <StepForm
          name={state.currentStep.name}
          onWaypointCancel={onWaypointCancel}
          handleStepNameChange={(event) => {
            console.log(state);
            setState((prevState) => ({
              ...prevState,
              currentStep: {
                ...prevState.currentStep,
                name: event.target.value,
              },
            }));
          }}
          handleNewLocation={handleNewLocation}
        />
      ),
    },
    {
      label: "Add Task Items to the Step",

      children: (
        <TaskItemListAndAdd
          taskItems={state.currentStep.taskItems}
          submitTaskItem={submitTaskItem}
        />
      ),
    },
  ];
  const onCancel = () => {
    setState({
      ...DEFAULT_STATE,
      currentStep: {
        name: "",
        taskItems: [],
      },
    });
  };

  const onSubmit = () => {
    const stepToSubmit = state.currentStep;
    setState({
      editing: false,
      creatingStep: false,
      currentStep: {
        name: "",
        taskItems: [],
      },
    });
    submitStep(stepToSubmit);
  };

  const listSteps: JSX.Element | null = !state.creatingStep ? (
    <Fragment>
      {steps.map((step) => {
        return <StepCard step={step} />;
      })}
    </Fragment>
  ) : null;
  const addStep: JSX.Element | null = state.creatingStep ? (
    <Fragment>
      <StepperFrame
        stepFrames={stepFrames}
        cancellable={true}
        handleCancel={onCancel}
        handleSubmit={onSubmit}
      />
      {/* <SubmitButtonsContainer>
        <Button variant="contained" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Add
        </Button>
      </SubmitButtonsContainer> */}
    </Fragment>
  ) : null;
  return (
    <StandardContainer>
      {listSteps}
      {addStep}
      {addStepButton}
    </StandardContainer>
  );
}
